import { Team } from '../types';

export const getTeamName = (team: Pick<Team, 'alias' | 'name' | 'short_code'>) => {
    return team.alias || team.name || team.short_code;
};
